








































import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class PaginationPanel extends Vue {
  @Prop({
    default: 0,
  })
  public total: number;
  @Prop({
    default: false,
  })
  public reset: boolean;
  public isFirst: boolean = true;
  public paginationOptions = {
    skip: 0,
    count: 10,
    currentPage: 1,
  };
  public lastPageNum = 0;
  pageSize = 10;
  /* 重置当前页 */
  @Watch("reset")
  public reloadChange(val: boolean) {
    if (val) {
      this.paginationOptions.currentPage = 1;
      this.paginationOptions.skip = 0;
      this.paginationOptions.count = 10;
      this.pageSize = 10;
    }
  }
  @Watch("total")
  public totalChange(newVal, oldVal) {
    this.total = newVal;
    this.lastPageNum = Math.ceil(newVal / this.paginationOptions.count);
    this.currentChange(this.paginationOptions.currentPage);
  }
  public firstPageBtnDisabled = true;
  public lastPageBtnDisabled = true;

  mounted() {}

  public handleCurrentChange(val) {
    console.log("111", val);

    this.firstPageBtnDisabled = val === 1 ? true : false;
    if (this.total == 0) {
      this.lastPageBtnDisabled = true;
    } else {
      this.lastPageBtnDisabled =
        val === Math.ceil(this.total / this.paginationOptions.count) ? true : false;
    }
    this.paginationOptions.currentPage = val;
    this.paginationOptions.skip =
      (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
    this.paginationOptions.skip =
      this.paginationOptions.skip < 0 ? 0 : this.paginationOptions.skip;
    this.$emit("onPaginationChange", this.paginationOptions);
  }
  public currentChange(val) {
    this.firstPageBtnDisabled = val === 1 ? true : false;
    if (this.total == 0) {
      this.lastPageBtnDisabled = true;
    } else {
      this.lastPageBtnDisabled =
        val === Math.ceil(this.total / this.paginationOptions.count) ? true : false;
    }
    this.paginationOptions.currentPage = val;
    this.paginationOptions.skip =
      (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
    this.paginationOptions.skip =
      this.paginationOptions.skip < 0 ? 0 : this.paginationOptions.skip;
  }
  public handleSizeChange(val) {
    console.log("222", val);

    this.paginationOptions.count = val;
    // this.paginationOptions.currentPage = 1;
    this.handleCurrentChange(this.paginationOptions.currentPage);
    if (Math.ceil(this.total / val) < this.paginationOptions.currentPage) {
      this.paginationOptions.skip = 0;
    } else {
      this.paginationOptions.skip =
        (this.paginationOptions.currentPage - 1) * this.paginationOptions.count;
      this.paginationOptions.skip =
        this.paginationOptions.skip < 0 ? 0 : this.paginationOptions.skip;
      this.$emit("onPaginationChange", this.paginationOptions);
    }
  }

  toFirstPage() {
    this.handleCurrentChange(1);
  }
  toLastPage() {
    this.paginationOptions.currentPage = Math.ceil(
      this.total / this.paginationOptions.count
    );
    this.handleCurrentChange(this.paginationOptions.currentPage);
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/PaginationPanel.vue